import Marionette from 'backbone.marionette';
import _ from "underscore-contrib";
import template from "../templates/signupForm.ejs";

export default Marionette.View.extend( {

   template: template,

   templateContext: function () {
      return {
        htmlId: function ( string ) {
           return string.replace( /[^a-zA-Z0-9_\s]/gi, '' ).replace( /[_\s]/g, '-' ).toLowerCase();
        },
        ...this.app.data
      }
   },

   ui: {
      manageSubmit: '#signup-submit',
      interests: '[data-interest-checkbox]',
      tags: '[data-tag-checkbox]'
   },

   events: {
      'submit': 'interestsSubmitted',
      'change @ui.tags': 'tagsChanged',
      'change @ui.interests': 'interestsChanged'
   },

   modelEvents: {
      'change:interests': 'interestsModelChanged',
      'change:tags': 'tagsModelChanged',
   },

   initialize: function ( options ) {
      this.mergeOptions( options, ['app'] );
   },

   interestsModelChanged: function ( model, changes = {}, options ) {
      this.getUI( 'interests' ).each( function () {
         this.checked = changes[this.name] !== undefined ? changes[this.name] : this.checked;
      } );
   },

   tagsModelChanged: function ( model, changes = {}, options ) {
      this.getUI( 'tags' ).each( function () {
         this.checked = changes[this.name] !== undefined ? changes[this.name] : this.checked;
      } );
   },

   /**
    * @param {JQuery.Event} event
    */
   interestsChanged: function (event) {
      /** @type boolean */
      const checked = event.currentTarget.checked;

      if (!checked) {
         const allInterests = this._getAllConfiguredInterests();
         const interest = allInterests.find(interest => interest.id === event.currentTarget.name);
         interest?.tags && this.getUI('tags').each(function () {
            if (interest.tags.includes(this.name)) {
               this.checked = false;
            }
         });
      }
   },

   /**
    * @param {JQuery.Event} event 
    */
   tagsChanged: function (event) {
      const checked = event.currentTarget.checked;

      if (checked) {
         const allInterests = this._getAllConfiguredInterests();
         const interest = allInterests.find(interest => interest.tags?.includes(event.currentTarget.name));
         interest && this.getUI('interests').each(function () {
            if (this.name === interest.id) {
               this.checked = true;
            }
         });
      }
   },

   /**
    * Get all interests for all sections and categories that have been set in configure.json
    * @returns {Array<{id: string, name: string, tags: Array<{id: string, name: string}>}>}
    */
   _getAllConfiguredInterests: function () {
      return _.flatten(_.walk.pluckRec(this.app.data, 'interests'));
   },

   interestsSubmitted: function ( event ) {
      if( this.getUI( 'manageSubmit' ).hasClass( 'disabled' ) ) {
         return false
      }
      this.getUI( 'manageSubmit' ).addClass( 'loading disabled' );
      this.model.save( {
         status: 'subscribed',
         email_address: this.model.get( 'email_address' ),
         interests: this.getUI( 'interests' ).get().reduce( ( result, checkbox ) => {
            return Object.assign( result, {[checkbox.name]: checkbox.checked} )
         }, {} ),
         tags: this.getUI( 'tags' ).get().reduce( ( result, checkbox ) => {
            return Object.assign( result, {[checkbox.name]: checkbox.checked} )
         }, {} )
      }, {
         patch: true,
         success: () => {
            const btnLabel = this.getUI( 'manageSubmit' ).html();
            this.getUI( 'manageSubmit' ).removeClass( 'loading disabled' ).text( 'Saved' );
            setTimeout( () => this.getUI( 'manageSubmit' ).html( btnLabel ), 5000 );

            this.app.showAlert('alert-success', this.app.data.alerts.signupSuccess);
         },
         error: ( model, response ) => {
            this.getUI( 'manageSubmit' ).removeClass( 'loading disabled' );
            if( response.status === 0 ) {
               this.app.showAlert('alert-danger', this.app.data.alerts.networkError);
            }
            else {
               this.app.showAlert('alert-danger', this.app.data.alerts.applicationError);
            }
         },
      } );
      return false
   },
} );
